<template>
  <div class="v_footer">
      <div class="v_pos clearfix">
         <div class="v_go clearfix">
      <dl>
        <dt>关于金赛德</dt>
        <dd>公司简介</dd>
        <dd>企业形象</dd>
        <dd>企业概况</dd>
        <dd>企业文化</dd>
        <dd>组织架构</dd>
        <dd>服务优势</dd>
        <dd>海外代理</dd>
        <dd>资质证书</dd>
        <dd>合作客户</dd>
      </dl>
      <dl>
        <dt>业务板块</dt>
        <dd>国际物流</dd>
        <dd>国际贸易</dd>
        <dd>供应链管理</dd>
        <dd>供应链融资</dd>
      </dl>
      <dl>
        <dt>解决方案</dt>
        <dd>电子</dd>
        <dd>工程</dd>
        <dd>化工</dd>
        <dd>汽车</dd>
        <dd>冷链</dd>
        <dd>木材</dd>
      </dl>
      <dl>
        <dt>新闻资讯</dt>
        <dd>公司简介</dd>
        <dd>行业资讯</dd>
      </dl>
      <dl>
        <dt>招贤纳士</dt>
        <dd>人才理念</dd>
        <dd>福利待遇</dd>
        <dd>培训成才</dd>
        <dd>职位信息</dd>
      </dl>
      <dl>
        <dt>联系我们</dt>
        <dd>联系方式</dd>
        <dd>服务网点</dd>
        <dd>分支机构</dd>
        <dd>金赛德</dd>
      </dl>
    </div>

    <div class="w_addres">
      <img src="../../assets/gzh.jpg" alt="">
    </div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    components: {

    }
  }

</script>

<style scoped>
.v_footer dl dt{
      font-size: 22px;
    font-weight: 700;
    color: #282828;
    line-height: 1.375;
    display: inline-block;
    position: relative;
    margin-top: 0;
}
.v_footer dl dd{
  font-size: 14px;
    color: #282828;
    line-height: 1.375;
    padding: 10px;
}
.v_footer{
      background: #f0f0f0; 
}
.v_pos{
  max-width: 1200px;
  padding-left: 15px;
  padding-right: 15px;
     margin-right: auto;
    margin-left: auto;
}
  .v_footer {
    min-height: 300px;
        padding-top: 54px;
  }

  .v_go {
    float: left;
    width: 90%;
  }

  .w_addres {
    float: right;
  }

  .v_go dl {
    float: left;
    width: 16%;
  }

</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue